import React from 'react';
import { observer } from 'mobx-react-lite';
import { QuickBetsContent } from './quickBetsContent';

export const Any = observer(
  ({ activeFreeBet, anyBetTypeData, selectedMarket, setSelectedMarket, activeTabIndex }) => {
    return (
      <QuickBetsContent
        marketData={anyBetTypeData}
        activeFreeBet={activeFreeBet}
        activeTabIndex={activeTabIndex}
        selectedMarket={selectedMarket}
        setSelectedMarket={setSelectedMarket}
      />
    );
  }
);
